module.exports = __webpack_public_path__ + "img/tourninouneur-widddi.75291963.jpg";